import { Button } from '@thanx/uikit/button'
import { Text } from '@thanx/uikit/text'

import { buildTranslate } from 'locales'

const t = buildTranslate('components.ai.picker.canonical')

type Props = {
  message: string
  disabled: boolean
  isLoading?: boolean
  onRetry: () => void
}

/** A failed lookup under a picker level, with a way to run it again */
const RetryAlert = ({ message, disabled, isLoading, onRetry }: Props) => (
  <div role="alert" className="d-flex align-items-center">
    <Text.BodyText5 color="cayenne50">{message}</Text.BodyText5>
    <Button
      kind="minimal"
      size="small"
      className="ml-xs"
      disabled={disabled}
      isLoading={isLoading}
      onClick={onRetry}
    >
      {t('retry')}
    </Button>
  </div>
)

export default RetryAlert
